// BlogCardsSection.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

const BlogCardsSection = () => {
  const blogPosts = [
    {
      date: 'March 10, 2024',
      title: 'Studying Abroad: Working Backwards From the Deadline',
      excerpt: 'Country, institution and course are really three separate decisions, and taking them in the wrong order is what makes the whole thing feel unmanageable. Here is the sequence we use with clients, from the budget conversation through to the day you accept an offer.',
      image: 'blog-1.jpg',
      link: '/blog/practical-guide-studying-abroad'
    },
    {
      date: 'July 18, 2024',
      title: 'Taking a Job Overseas: What to Sort Out, and in Which Order',
      excerpt: 'Most people start with the job adverts and hit the immigration rules later, which is the expensive way round. This piece runs the other way: visa route first, then your qualifications, then the market, then the interview.',
      image: 'blog-2.jpg',
      link: '/blog/working-abroad-preparation'
    },
    {
      date: 'July 24, 2024',
      title: 'Should You Go At All? A Sober Look Before You Commit',
      excerpt: 'Before the applications and the visa forms, there is a plainer question worth sitting with. We look at the real cost, the honest timeline, the reasons people give for going, and the points at which it is still sensible to change your mind.',
      image: 'blog-3.jpg',
      link: '/blog/informed-decisions-study-work-abroad'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-3 gap-6">
          {blogPosts.map((post, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Link to={post.link} className="group block">
                <div className="relative h-96 bg-gradient-to-br from-primary to-secondary overflow-hidden">
                  {/* Placeholder for background image - replace with actual image */}
                  <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${require(`../assets/${post.image}`)})` }}></div>
                  
                  {/* Dark Overlay */}
                  <div className="absolute inset-0 bg-primary/60"></div>
                  
                  {/* Content */}
                  <div className="absolute inset-0 p-8 flex flex-col text-white">
                    <div className="flex items-center gap-2 text-sm font-light mb-6">
                      <Calendar size={18} />
                      <span>{post.date}</span>
                    </div>
                    
                    <h3 className="text-xl font-normal mb-4 leading-tight">
                      {post.title}
                    </h3>
                    
                    <p className="text-sm font-light leading-relaxed opacity-90 mb-auto line-clamp-2">
                      {post.excerpt}
                    </p>
                    
                    <div className="flex justify-end mt-8">
                      <ArrowRight size={40} strokeWidth={1} className="text-white group-hover:translate-x-2 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogCardsSection;
